import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/components/Button';
import { Trans } from 'react-i18next';
import s from './Notification.styles';

const ErrorMessageWithButton = ({ message, buttonlabel = 'OK', onButtonClick }) => {
  return (
    <s.ErrorMessageWrapper>
        {message}      
        <Button sm solid type="button" onClick={() => onButtonClick}>
            <Trans>{buttonlabel}</Trans>
        </Button>
    </s.ErrorMessageWrapper>
  );
};

ErrorMessageWithButton.propTypes = {
  message: PropTypes.any,
  buttonlabel: PropTypes.string,
  onButtonClick: PropTypes.func,
};

export default React.memo(ErrorMessageWithButton);
